import classNames from "classnames";

export type TagType = "success" | "danger" | "info" | "pending";

export const TagCard = ({
  text,
  type,
  className = "",
}: {
  text: string;
  type: TagType;
  className?: string;
}) => {
  return (
    <p
      className={classNames(
        `px-3 py-1 rounded-[4px] text-xs font-medium w-fit
        `,
        {
          "text-pry-green-300 bg-light-green-bg-500": type === "success",
          "text-red-200 bg-light-red-bg-50": type === "danger",
          "text-info-purple bg-light-purple/50": type === "info",
          "text-warning-yellow bg-warning-yellow-bg-50": type === "pending",
        },
        className
      )}
    >
      {text}
    </p>
  );
};
